import {css} from "@panda/css";

import {HOME_MATCH_PREFERENCES_SURVEY_SECTIONS} from "../../constants/preferences/home_match_preferences_survey_content";
import {IHomeMatchPreferencesWizardMapActions} from "../../hooks/preferences/use_home_match_preferences_wizard_location_map";
import {HomeMatchSentLeadMessage} from "../home_match_details_modal/HomeMatchSentLeadMessage";
import {HomeMatchPreferencesSurveyAdditionalFields} from "./fields/HomeMatchPreferencesSurveyAdditionalFields";
import {HomeMatchPreferencesSurveyBudgetFields} from "./fields/HomeMatchPreferencesSurveyBudgetFields";
import {HomeMatchPreferencesSurveyFeatureFields} from "./fields/HomeMatchPreferencesSurveyFeatureFields";
import {HomeMatchPreferencesSurveyPropertyTypeFields} from "./fields/HomeMatchPreferencesSurveyPropertyTypeFields";
import {HomeMatchPreferencesSurveySizeFields} from "./fields/HomeMatchPreferencesSurveySizeFields";
import {HomeMatchPreferencesSurveyLocationSection} from "./HomeMatchPreferencesSurveyLocationSection";
import {HomeMatchPreferencesSurveySection} from "./HomeMatchPreferencesSurveySection";

const {ADDITIONAL, BUDGET, FEATURES, LOCATION, PROPERTY_TYPE, SIZE} = HOME_MATCH_PREFERENCES_SURVEY_SECTIONS;

interface IProps {
    isLocationMapOpen: boolean;
    isMobile: boolean | null;
    isOpen: boolean;
    locationMapActions: IHomeMatchPreferencesWizardMapActions | null;
    onMapActionsChange: (actions: IHomeMatchPreferencesWizardMapActions | null) => void;
    onMapOpenChange: (isOpen: boolean) => void;
    showSentLeadMessage: boolean;
}

export const HomeMatchPreferencesSurveyFields = (props: IProps) => {
    const {isLocationMapOpen, isMobile, isOpen, locationMapActions, onMapActionsChange, onMapOpenChange, showSentLeadMessage} = props;

    return (
        <>
            {showSentLeadMessage && <HomeMatchSentLeadMessage isSentLeadMessageVisible />}

            <HomeMatchPreferencesSurveySection sectionId="property-type" title={PROPERTY_TYPE}>
                <HomeMatchPreferencesSurveyPropertyTypeFields />
            </HomeMatchPreferencesSurveySection>

            <HomeMatchPreferencesSurveySection sectionId="location" title={LOCATION}>
                <HomeMatchPreferencesSurveyLocationSection
                    isMapOpen={isLocationMapOpen}
                    key={isOpen ? "open" : "closed"}
                    mapActions={locationMapActions}
                    onMapActionsChange={onMapActionsChange}
                    onMapOpenChange={onMapOpenChange}
                />
            </HomeMatchPreferencesSurveySection>

            <div className={isMobile && isLocationMapOpen ? hiddenStyle : tailStyle}>
                <HomeMatchPreferencesSurveySection sectionId="budget" title={BUDGET}>
                    <HomeMatchPreferencesSurveyBudgetFields />
                </HomeMatchPreferencesSurveySection>

                <HomeMatchPreferencesSurveySection sectionId="size" title={SIZE}>
                    <HomeMatchPreferencesSurveySizeFields />
                </HomeMatchPreferencesSurveySection>

                <HomeMatchPreferencesSurveySection sectionId="features" title={FEATURES}>
                    <HomeMatchPreferencesSurveyFeatureFields />
                </HomeMatchPreferencesSurveySection>

                <HomeMatchPreferencesSurveySection sectionId="additional" title={ADDITIONAL}>
                    <HomeMatchPreferencesSurveyAdditionalFields />
                </HomeMatchPreferencesSurveySection>
            </div>
        </>
    );
};

const hiddenStyle = css({
    display: "none"
});

const tailStyle = css({
    display: "contents"
});
import {css} from "@panda/css";

import {HOME_MATCH_PREFERENCES_SURVEY_SECTIONS} from "../../constants/preferences/home_match_preferences_survey_content";
import {IHomeMatchPreferencesWizardMapActions} from "../../hooks/preferences/use_home_match_preferences_wizard_location_map";
import {HomeMatchSentLeadMessage} from "../home_match_details_modal/HomeMatchSentLeadMessage";
import {HomeMatchPreferencesSurveyAdditionalFields} from "./fields/HomeMatchPreferencesSurveyAdditionalFields";
import {HomeMatchPreferencesSurveyBudgetFields} from "./fields/HomeMatchPreferencesSurveyBudgetFields";
import {HomeMatchPreferencesSurveyFeatureFields} from "./fields/HomeMatchPreferencesSurveyFeatureFields";
import {HomeMatchPreferencesSurveyPropertyTypeFields} from "./fields/HomeMatchPreferencesSurveyPropertyTypeFields";
import {HomeMatchPreferencesSurveySizeFields} from "./fields/HomeMatchPreferencesSurveySizeFields";
import {HomeMatchPreferencesSurveyLocationSection} from "./HomeMatchPreferencesSurveyLocationSection";
import {HomeMatchPreferencesSurveySection} from "./HomeMatchPreferencesSurveySection";

const {ADDITIONAL, BUDGET, FEATURES, LOCATION, PROPERTY_TYPE, SIZE} = HOME_MATCH_PREFERENCES_SURVEY_SECTIONS;

interface IProps {
    isLocationMapOpen: boolean;
    isMobile: boolean | null;
    isOpen: boolean;
    locationMapActions: IHomeMatchPreferencesWizardMapActions | null;
    onMapActionsChange: (actions: IHomeMatchPreferencesWizardMapActions | null) => void;
    onMapOpenChange: (isOpen: boolean) => void;
    showSentLeadMessage: boolean;
}

export const HomeMatchPreferencesSurveyFields = (props: IProps) => {
    const {isLocationMapOpen, isMobile, isOpen, locationMapActions, onMapActionsChange, onMapOpenChange, showSentLeadMessage} = props;

    return (
        <>
            {showSentLeadMessage && <HomeMatchSentLeadMessage isSentLeadMessageVisible />}

            <HomeMatchPreferencesSurveySection sectionId="property-type" title={PROPERTY_TYPE}>
                <HomeMatchPreferencesSurveyPropertyTypeFields />
            </HomeMatchPreferencesSurveySection>

            <HomeMatchPreferencesSurveySection sectionId="location" title={LOCATION}>
                <HomeMatchPreferencesSurveyLocationSection
                    isMapOpen={isLocationMapOpen}
                    key={isOpen ? "open" : "closed"}
                    mapActions={locationMapActions}
                    onMapActionsChange={onMapActionsChange}
                    onMapOpenChange={onMapOpenChange}
                />
            </HomeMatchPreferencesSurveySection>

            <div className={isMobile && isLocationMapOpen ? hiddenStyle : tailStyle}>
                <HomeMatchPreferencesSurveySection sectionId="budget" title={BUDGET}>
                    <HomeMatchPreferencesSurveyBudgetFields />
                </HomeMatchPreferencesSurveySection>

                <HomeMatchPreferencesSurveySection sectionId="size" title={SIZE}>
                    <HomeMatchPreferencesSurveySizeFields />
                </HomeMatchPreferencesSurveySection>

                <HomeMatchPreferencesSurveySection sectionId="features" title={FEATURES}>
                    <HomeMatchPreferencesSurveyFeatureFields />
                </HomeMatchPreferencesSurveySection>

                <HomeMatchPreferencesSurveySection sectionId="additional" title={ADDITIONAL}>
                    <HomeMatchPreferencesSurveyAdditionalFields />
                </HomeMatchPreferencesSurveySection>
            </div>
        </>
    );
};

const hiddenStyle = css({
    display: "none"
});

const tailStyle = css({
    display: "contents"
});
